import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel } from '~/shared/model'

export default class RefreshTokenModel extends BaseModel {
  static override constructorName = 'RefreshTokenModel'

  public accessToken: string = ''
  public refreshToken: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.accessToken = String(data.accessToken ?? data.access_token ?? '')
      this.refreshToken = String(data.refreshToken ?? data.refresh_token ?? '')
    }
  }
}
